<template>
  <div class="display-input">
    <div class="form-group row">
      <label :for="options.name" class="col-sm-4 col-form-label">
        {{ options.label }}
      </label>
      <div class="col-sm-8 p-2">
        <div>{{ value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DisplayInput',
  props: {
    value: {
      type: [String, Number]
    },
    options: {
      type: Object
    }
  },
  data () {
    return {
      isValid: true
    }
  },
  methods: {
    validate () {
      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/DisplayInput.vue